module.exports = __webpack_public_path__ + "img/about-01.7d9ff72c.jpg";